/* eslint-disable react/no-danger */
import React from 'react';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'gatsby';
import BoxedContainer from '../layouts/BoxedContainer';

export default function IntroTextWithIconList({ id, data }) {
  const { title, titleLogo, text, icons, cta } = data;
  return (
    <section id={id} className='pt-[40px]'>
      <BoxedContainer className="regular">
        <div className="flex items-center w-full">
          <div className="flex flex-col xl:gap-y-[31px] gap-y-[18px] w-full">
            <div className='w-full relative'>
            <h3
              className={`lg:text-2xl text-[35px] text-black leading-none 
              font-roboto-condensed-bold uppercase 
              ${titleLogo 
                ? 'md:max-w-[550px] lg:max-w-[580px] xl:max-w-[650px] 2xl:max-w-[870px]'
                :'max-w-[970px]'}`
              }
              dangerouslySetInnerHTML={{ __html: title }}
            />

            {isEmpty(titleLogo) || (
              <LazyLoadImage
              src={titleLogo.url}
              className="max-w-[100px] mt-4 mb-2 md:m-0 md:max-w-[170px] 
              md:absolute md:top-0 md:right-0"
            />
            )}
            </div>
            <div
              className={`text-[14px] 2xl:text-[16px] leading-relaxed text-primary 
              ${titleLogo 
                ? 'md:max-w-[550px] lg:max-w-[580px] xl:max-w-[650px] 2xl:max-w-[870px]'
                :'max-w-[970px]'
              } 
              font-roboto-regular [&>p:not(:last-child)]:mb-5 
              [&>p:nth-child(2)]:2xl:text-[20px] [&>p:nth-child(2)]:xl:text-[18px] 
              [&>p:nth-child(2)]:text-[16px]`
            } 
              dangerouslySetInnerHTML={{__html: text}} />
          </div>
        </div>

        {isEmpty(icons) || (
          <div className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 
            ${icons.length === 3 ? '2xl:grid-cols-4 max-w-[1080px]' : '2xl:grid-cols-6'} 
            pt-14 gap-x-4 gap-y-8 md:gap-8 4xl:gap-10 auto-cols-auto`}>
            {icons.map((item, index) => (
              <div key={index} className="flex text-center flex-col">
                <div className="flex h-[55px] xl:h-[96px] justify-center items-start w-full">
                  <LazyLoadImage
                    src={item?.content?.icon?.url}
                    className="h-auto max-w-[155px] max-h-[40px] xl:max-h-[61px]"
                  />
                </div>
                <p className='font-roboto-condensed-bold max-w-[220px] mx-auto
                text-[14px] sm:text-[16px] 2xl:text-[18px] 4xl:text-[20px]'>{item.content.title}</p>
              </div>
            ))}
          </div>
        )}

        {isEmpty(cta) || (
          <div className='pt-14 mb-10 lg:mb-5'>
          <Link 
          to={cta.url}
          className='bg-red hover:shadow-sm hover:bg-white hover:text-black
        text-xs text-white uppercase rounded-sm font-roboto-bold border border-red 
        flex cursor-pointer items-center justify-center max-w-[170px] 
        xl:w-[170px] w-auto lg2:w-[150px] 
        min-h-[42px] px-6 py-2 text-center font-bold transition duration-300 ease-in-out'
          >{cta.name}</Link>
          </div>
        )}
      </BoxedContainer>
    </section>
  );
}
